module.exports = __webpack_public_path__ + "src/images/pic_default.png";